// extracted by css-extract-rspack-plugin
export default {"wrapper":"_149427bb","title":"_6ec49b68","imageWrapper":"_e522d6bc","image":"_77e07c4f"};